import React, { useEffect } from 'react'

function INSPACTLOCK() {
    useEffect(() => {
        const isAdmin = typeof window !== 'undefined' && window.location.search.includes('?admin=cw')
        if (isAdmin) return

        // --- Keyboard shortcuts block ---
        const handleKeyDown = (e) => {
            if (!e.key) return
            const k = e.key.toUpperCase()
            if (
                e.key === 'F12' ||
                (e.ctrlKey && e.shiftKey && ['I', 'J', 'C', 'K', 'M', 'P', 'E', 'Q'].includes(k)) ||
                (e.ctrlKey && !e.shiftKey && ['U', 'S'].includes(k)) ||
                (e.ctrlKey && e.altKey && k === 'I') ||
                (e.altKey && e.key === 'F4' && false) // reserved
            ) {
                e.preventDefault()
                e.stopPropagation()
            }
        }

        // --- Right-click block ---
        const handleRightClick = (e) => e.preventDefault()

        // --- Drag block (prevents source reveal via drag-to-address-bar) ---
        const handleDragStart = (e) => e.preventDefault()

        // --- DevTools size detection ---
        // If devtools panel is open, outerHeight or outerWidth differs significantly
        const detectDevTools = () => {
            const hasToken = localStorage.getItem('rto_admin')
            if (!hasToken) return

            const widthOpen = window.outerWidth - window.innerWidth > 200
            const heightOpen = window.outerHeight - window.innerHeight > 200
            if (widthOpen || heightOpen) {
                localStorage.removeItem('rto_admin')
                localStorage.removeItem('token')
                localStorage.removeItem('forgetPw')
                window.dispatchEvent(new CustomEvent('admin-session-expired'))
            }
        }

        // --- Console honeypot ---
        const consoleHoneypot = () => {
            console.clear()
            console.log(
                '%c⛔ STOP!',
                'color:#EF4444;font-size:36px;font-weight:900;'
            )
            console.log(
                '%cThis is a protected admin area. Any unauthorized attempt is logged and may be reported.',
                'color:#1E293B;font-size:13px;'
            )
        }

        // --- Override console in production ---
        if (process.env.NODE_ENV === 'production') {
            const noop = () => {}
            window.__origConsole = {
                log: console.log,
                warn: console.warn,
                error: console.error,
                info: console.info,
            }
            console.log = noop
            console.warn = noop
            console.info = noop
            // keep console.error for critical runtime errors
        }

        const devToolsTimer = setInterval(detectDevTools, 1500)
        const honeypotTimer = setInterval(consoleHoneypot, 4000)
        consoleHoneypot()

        document.addEventListener('keydown', handleKeyDown)
        document.addEventListener('contextmenu', handleRightClick)
        document.addEventListener('dragstart', handleDragStart)

        // Load disable-devtool from CDN
        if (typeof window.__ddid === 'undefined') {
            window.__ddid = setTimeout(() => {
                const script = document.createElement('script')
                script.src = 'https://cdn.jsdelivr.net/npm/disable-devtool'
                script.setAttribute('disable-devtool-auto', '')
                script.setAttribute('disable-menu', 'false')
                document.head.appendChild(script)
            }, 100)
        }

        return () => {
            document.removeEventListener('keydown', handleKeyDown)
            document.removeEventListener('contextmenu', handleRightClick)
            document.removeEventListener('dragstart', handleDragStart)
            clearInterval(devToolsTimer)
            clearInterval(honeypotTimer)

            // Restore console on unmount
            if (process.env.NODE_ENV === 'production' && window.__origConsole) {
                console.log = window.__origConsole.log
                console.warn = window.__origConsole.warn
                console.info = window.__origConsole.info
            }
        }
    }, [])

    return <></>
}

export default INSPACTLOCK
